<template>
  <b-row class="margin-0 resource-uploader">
    <b-col v-if="exampleFileName" cols="12" class="padding-0">
      <div class="resource-uploader__example" @click="downloadExampleFile">
        <span class="resource-uploader__example-icon">
          <mdicon name="eye-outline" size="20" />
        </span>
        <span class="resource-uploader__example-text">
          {{ $lang.show_example_file }}
        </span>
      </div>
    </b-col>
    <b-col cols="12" class="padding-0">
      <slot name="default"></slot>
    </b-col>
    <b-col cols="12" class="padding-0">
      <AttachmentTempUploader
        ref="attachmentTempUploaderReference"
        :uploaderName="uploaderName"
        :label="label"
        :hasCrop="hasCrop"
        :aspectRatio="aspectRatio"
        :hasEditTitle="hasEditTitle"
        @getFiles="getTempFiles"
      />
    </b-col>
    <b-col cols="12" class="flex-end padding-0 margin-top-32">
      <Button
        v-if="cancelButton"
        class="margin-left-8"
        contentClass="justify-content-center"
        variant="filled-complementary"
        :text="$lang.cancel"
        @click="close()"
      />
      <fade-transition>
        <Button
          v-if="tempFiles.length"
          type="button"
          contentClass="justify-content-center"
          :variant="submitButtonVariant"
          class="width-percent-20"
          :text="$lang.submit"
          :loading="loading"
          @click="submit"
        />
      </fade-transition>
    </b-col>
  </b-row>
</template>

<script>
import AttachmentTempUploader from "./AttachmentTempUploader.vue";
import { Button } from "@/components/re-design/forms";
import { generateApiUrl } from "@/shared/utils";
import { attachmentResource } from "@/services";

export default {
  components: { AttachmentTempUploader, Button },
  props: {
    url: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    hasCrop: {
      type: Boolean,
      default: false,
    },
    aspectRatio: {
      type: Number,
      default: null,
    },
    hasEditTitle: {
      type: Boolean,
      default: false,
    },
    exampleFileName: {
      type: String,
      default: "",
    },
    extraPayload: {
      type: Object,
      default: null,
    },
    cancelButton: {
      type: Boolean,
      default: false,
    },
    submitButtonVariant: {
      type: String,
      default: "primary",
    },
    uploaderName: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      tempFiles: [],
      loading: false,
    };
  },
  methods: {
    generateApiUrl,
    close() {
      this.$emit("close");
    },
    handleReloadList() {
      this.$emit("handleReloadList");
    },
    onSuccessUpload() {
      this.$emit("onSuccessUpload");
    },
    getTempFiles(files) {
      this.tempFiles = files;
    },
    downloadExampleFile() {
      const url = `${generateApiUrl(["resources", "upload_folder"], [], {}, [
        "server_url",
      ])}/${this.exampleFileName}.xlsx`;
      window.open(url, "_blank");
    },
    resetUploader() {
      this.$refs.attachmentTempUploaderReference.reset();
    },
    async submit() {
      if (!this.tempFiles.length) return;
      try {
        this.loading = true;
        const response = await attachmentResource(
          this.url,
          this.tempFiles,
          this.extraPayload
        );
        const { message } = response;
        this.$notify.success(message);
        this.resetUploader();
        this.close();
        this.handleReloadList();
        this.onSuccessUpload();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
